module.exports = __webpack_public_path__ + "static/media/gc_logo_orange.567cefdb.png";